import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const gestaoMaavRoutes: Routes = [
  {
    path: 'maav',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Manter MAAv',
      breadcrumb: [{ label: 'MAAv' }],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./maav.component').then((m) => m.MaavComponent),
        data: {
          title: 'Gestão de MAAv',
          roles: [Role.MAAV_CONSULTAR],
          breadcrumb: [{ label: 'MAAv', url: '/maav' }],
        },
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/maav-dashboard.component').then(
            (m) => m.MaavDashboardComponent,
        ),
        data: {
          title: 'Dashboard MAAv',
          roles: [Role.MAAV_VISUALIZACAO_DASHBOARD],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Dashboard', url: '/maav/dashboard' },
          ],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./maav-form/maav-form.component').then((m) => m.MaavFormComponent),
        data: {
          title: 'Cadastrar MAAv',
          roles: [Role.MAAV_CADASTRAR],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Cadastrar', url: '/maav/cadastrar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./maav-form/maav-form.component').then((m) => m.MaavFormComponent),
        data: {
          title: 'Visualizar MAAv',
          roles: [Role.MAAV_VISUALIZAR],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Visualizar', url: '/maav/visualizar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./maav-form/maav-form.component').then((m) => m.MaavFormComponent),
        data: {
          title: 'Editar MAAv',
          roles: [Role.MAAV_EDITAR],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Editar', url: '/maav/editar' },
          ],
        },
      },
      {
        path: 'participantes/:id',
        loadComponent: () =>
          import('./participante/maav-participantes.component').then(
            (m) => m.MaavParticipantesComponent,
          ),
        data: {
          title: 'Gestão de MAAv - Médicos Participantes',
          roles: [Role.MAAV_VISUALIZAR_MEDICOS_PARTICIPANTES],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Médicos Participantes', url: '/maav/participantes' },
          ],
        },
      },
      {
        path: 'distribuicao/:id',
        loadComponent: () =>
          import('./distribuicao/maav-distribuicao.component').then(
            (m) => m.MaavDistribuicaoComponent,
          ),
        data: {
          title: 'Distribuição de Médicos MAAv',
          roles: [
            Role.ROLE_MAAV_DISTRIBUIR_PROFISSIONAL_AUTOMATICO,
            Role.ROLE_MAAV_DISTRIBUIR_PROFISSIONAL_MANUAL,
          ],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Distribuição de Médicos', url: '/maav/distribuicao' },
          ],
        },
      },
      {
        path: 'distribuicao/:id/manual',
        loadComponent: () =>
          import('./distribuicao/maav-distribuicao.component').then(
            (m) => m.MaavDistribuicaoComponent,
          ),
        data: {
          title: 'Distribuição de Médicos - MAAv',
          roles: [Role.ROLE_MAAV_DISTRIBUIR_PROFISSIONAL_MANUAL],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Distribuição de Médicos', url: '/maav/distribuicao' },
            { label: 'Distribuição Manual' },
          ],
        },
      },
      {
        path: 'distribuicao/:id/local/:localId',
        loadComponent: () =>
          import(
            './distribuicao/medicos-associados/maav-medicos-associados.component'
          ).then((m) => m.MaavMedicosAssociadosComponent),
        data: {
          title: 'Médicos Associados MAAv',
          roles: [
            Role.ROLE_MAAV_DISTRIBUIR_PROFISSIONAL_AUTOMATICO,
            Role.ROLE_MAAV_DISTRIBUIR_PROFISSIONAL_MANUAL,
          ],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Distribuição de Médicos', url: '/maav/distribuicao' },
            { label: 'Médicos Associados' },
          ],
        },
      },
      {
        path: 'avaliacao/:id',
        loadComponent: () =>
          import('./avaliacao/maav-avaliacao.component').then(
            (m) => m.MaavAvaliacaoComponent,
          ),
        data: {
          title: 'Controle de Presença e Resultados',
          roles: [Role.MAAV_AVALIACAO],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Controle de Presença e Resultados' },
          ],
        },
      },
      {
        path: 'enviar-email-lote',
        loadComponent: () =>
          import('./email-lote/maav-email-lote.component').then(
            (m) => m.MaavEmailLoteComponent,
          ),
        data: {
          title: 'Enviar E-mail em Lote',
          roles: [Role.MAAV_ENVIAR_EMAIL_LOTE],
          breadcrumb: [
            { label: 'MAAv', url: '/maav' },
            { label: 'Enviar E-mail em Lote' },
          ],
        },
      },
    ],
  },
];
